import React, { useMemo } from "react";
import { FiRotateCcw, FiSearch } from "react-icons/fi";

const fieldClass =
  "w-full rounded-2xl border border-slate-300 bg-white px-4 py-2.5 text-sm text-slate-900 outline-none transition focus:border-sky-500 focus:ring-2 focus:ring-sky-100 dark:border-slate-700 dark:bg-slate-950 dark:text-slate-100 dark:focus:ring-sky-950";

export default function FiltersBar({
  q,
  onQ,
  locale,
  onLocale,
  parentId,
  onParentId,
  parents = [],
  activeFilter,
  onActiveFilter,
  limit,
  onLimit,
  onSubmit,
  onReset,
}) {
  const parentOptions = useMemo(() => {
    const root = [{ id: "", title: "Toutes les pages" }];

    const sorted = [...parents].sort((a, b) =>
      String(a.title || "").localeCompare(String(b.title || ""), "fr")
    );

    return root.concat(sorted);
  }, [parents]);

  return (
    <form
      onSubmit={onSubmit}
      className="grid gap-3 xl:grid-cols-[minmax(260px,1fr)_110px_220px_145px_120px_auto_auto] xl:items-end"
    >
      <Field label="Mots-clés">
        <div className="relative">
          <FiSearch className="pointer-events-none absolute left-4 top-1/2 -translate-y-1/2 text-slate-400" />

          <input
            value={q}
            onChange={(e) => onQ(e.target.value)}
            placeholder="Titre, slug, contenu…"
            className={`${fieldClass} pl-11`}
          />
        </div>
      </Field>

      <Field label="Langue">
        <select
          value={locale}
          onChange={(e) => onLocale(e.target.value)}
          className={fieldClass}
        >
          <option value="fr">fr</option>
        </select>
      </Field>

      <Field label="Parent">
        <select
          value={parentId}
          onChange={(e) => onParentId(e.target.value)}
          className={fieldClass}
        >
          {parentOptions.map((p) => (
            <option key={String(p.id)} value={p.id}>
              {p.title}
            </option>
          ))}
        </select>
      </Field>

      <Field label="Statut">
        <select
          value={activeFilter}
          onChange={(e) => onActiveFilter(e.target.value)}
          className={fieldClass}
        >
          <option value="all">Tous</option>
          <option value="active">Actifs</option>
          <option value="inactive">Inactifs</option>
        </select>
      </Field>

      <Field label="Par page">
        <select
          value={limit}
          onChange={(e) => onLimit(Number(e.target.value) || 20)}
          className={fieldClass}
        >
          {[10, 20, 50, 100].map((n) => (
            <option key={n} value={n}>
              {n}
            </option>
          ))}
        </select>
      </Field>

      <button
        type="submit"
        className="inline-flex items-center justify-center gap-2 rounded-2xl bg-slate-950 px-4 py-2.5 text-sm font-bold text-white transition hover:bg-slate-800 dark:bg-slate-100 dark:text-slate-950 dark:hover:bg-white"
      >
        <FiSearch />
        Rechercher
      </button>

      <button
        type="button"
        onClick={onReset}
        className="inline-flex items-center justify-center gap-2 rounded-2xl border border-slate-200 bg-white px-4 py-2.5 text-sm font-bold text-slate-700 transition hover:bg-slate-50 dark:border-slate-700 dark:bg-slate-950 dark:text-slate-200 dark:hover:bg-slate-800"
      >
        <FiRotateCcw />
        Réinitialiser
      </button>
    </form>
  );
}

function Field({ label, children }) {
  return (
    <label className="block">
      <span className="mb-1.5 block text-xs font-bold uppercase tracking-wide text-slate-500 dark:text-slate-400">
        {label}
      </span>
      {children}
    </label>
  );
}